export const messages = {
  en: {
    integralRule: {
      addTitle: 'Add Integral Rule',
      editTitle: 'Edit Integral Rule',
      deleteTitle: 'Delete Integral Rule',
      deleteConfirm: 'Are you sure to delete this integral rule?',
      ruleName: 'Rule Name',
      ruleNamePlaceholder: 'Please enter rule name',
      ruleNameRequired: 'Rule name is required',
      ruleNameMaxLength: 'Rule name cannot exceed 64 characters',
      remark: 'Remark',
      remarkPlaceholder: 'Please enter remark',
      remarkRequired: 'Remark is required',
      remarkMaxLength: 'Remark cannot exceed 512 characters',
      ruleIdRequired: 'Rule ID is required',
      selectRule: 'Please select a rule first',
      
      // Config related
      addConfigTitle: 'Add Integral Config',
      configId: 'Config ID',
      configName: 'Config Name',
      configPlaceholder: 'Please select config',
      configRequired: 'Config is required',
      deleteConfigConfirm: 'Are you sure to delete this config?',
      computingFormula: 'Computing Formula',
      squarePrice: 'Square Price',
      additionalAmount: 'Additional Amount',
      scale: 'Scale',
      
      // Fee related
      addFeeTitle: 'Add Payment Time',
      editFeeTitle: 'Edit Payment Time',
      feeId: 'Fee ID',
      payTimeRange: 'Payment Time Range',
      payStartTime: 'Start Time',
      payStartTimePlaceholder: 'Select start time',
      payStartTimeRequired: 'Start time is required',
      payEndTime: 'End Time',
      payEndTimePlaceholder: 'Select end time',
      payEndTimeRequired: 'End time is required',
      payEndTimeAfterStart: 'End time must be after start time',
      deleteFeeConfirm: 'Are you sure to delete this payment time?',
      feeIdRequired: 'Fee ID is required',
      
      // Tab names
      integralRuleConfig: 'Integral Standard',
      integralRuleFee: 'Payment Time',
      
      // Messages
      fetchError: 'Failed to fetch data',
      selectRuleFirst: 'Please select a rule first'
    }
  },
  zh: {
    integralRule: {
      addTitle: '添加积分规则',
      editTitle: '编辑积分规则',
      deleteTitle: '删除积分规则',
      deleteConfirm: '确定删除该积分规则吗？',
      ruleName: '规则名称',
      ruleNamePlaceholder: '请输入规则名称',
      ruleNameRequired: '规则名称不能为空',
      ruleNameMaxLength: '规则名称不能超过64个字符',
      remark: '备注',
      remarkPlaceholder: '请输入备注',
      remarkRequired: '备注不能为空',
      remarkMaxLength: '备注不能超过512个字符',
      ruleIdRequired: '规则ID不能为空',
      selectRule: '请先选择规则',
      
      // Config related
      addConfigTitle: '添加积分标准',
      configId: '配置ID',
      configName: '配置名称',
      configPlaceholder: '请选择配置',
      configRequired: '配置不能为空',
      deleteConfigConfirm: '确定删除该配置吗？',
      computingFormula: '计算公式',
      squarePrice: '单价',
      additionalAmount: '固定积分',
      scale: '进位',
      
      // Fee related
      addFeeTitle: '添加缴费时间',
      editFeeTitle: '编辑缴费时间',
      feeId: '费用ID',
      payTimeRange: '缴费时间范围',
      payStartTime: '开始时间',
      payStartTimePlaceholder: '选择开始时间',
      payStartTimeRequired: '开始时间不能为空',
      payEndTime: '结束时间',
      payEndTimePlaceholder: '选择结束时间',
      payEndTimeRequired: '结束时间不能为空',
      payEndTimeAfterStart: '结束时间必须晚于开始时间',
      deleteFeeConfirm: '确定删除该缴费时间吗？',
      feeIdRequired: '费用ID不能为空',
      
      // Tab names
      integralRuleConfig: '积分标准',
      integralRuleFee: '缴费时间',
      
// Messages
      fetchError: '獲取數據失敗',
      selectRuleFirst: '請先選擇規則'
    }
  },
  'zh-TW': {
    integralRule: {
      addTitle: '添加積分規則',
      editTitle: '編輯積分規則',
      deleteTitle: '刪除積分規則',
      deleteConfirm: '確定刪除該積分規則嗎？',
      ruleName: '規則名稱',
      ruleNamePlaceholder: '請輸入規則名稱',
      ruleNameRequired: '規則名稱不能為空',
      ruleNameMaxLength: '規則名稱不能超過64個字符',
      remark: '備註',
      remarkPlaceholder: '請輸入備註',
      remarkRequired: '備註不能為空',
      remarkMaxLength: '備註不能超過512個字符',
      ruleIdRequired: '規則ID不能為空',
      selectRule: '請先選擇規則',
      
      // Config related
      addConfigTitle: '添加積分標準',
      configId: '配置ID',
      configName: '配置名稱',
      configPlaceholder: '請選擇配置',
      configRequired: '配置不能為空',
      deleteConfigConfirm: '確定刪除該配置嗎？',
      computingFormula: '計算公式',
      squarePrice: '單價',
      additionalAmount: '固定積分',
      scale: '進位',
      
      // Fee related
      addFeeTitle: '添加繳費時間',
      editFeeTitle: '編輯繳費時間',
      feeId: '費用ID',
      payTimeRange: '繳費時間範圍',
      payStartTime: '開始時間',
      payStartTimePlaceholder: '選擇開始時間',
      payStartTimeRequired: '開始時間不能為空',
      payEndTime: '結束時間',
      payEndTimePlaceholder: '選擇結束時間',
      payEndTimeRequired: '結束時間不能為空',
      payEndTimeAfterStart: '結束時間必須晚於開始時間',
      deleteFeeConfirm: '確定刪除該繳費時間嗎？',
      feeIdRequired: '費用ID不能為空',
      
      // Tab names
      integralRuleConfig: '積分標準',
      integralRuleFee: '繳費時間',
      
      // Messages
      fetchError: '獲取數據失敗',
      selectRuleFirst: '請先選擇規則'
    }
  }
}